import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../Components/AuthLayout';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useDispatch, useSelector } from 'react-redux';
import { login, clearAuthError } from '../redux/actions/authActions';

// const inputStyle = {
//   background: '#fff',
//   borderRadius: 4,
//   fontSize: 15,
//   color: '#111',
// };
// const inputSx = {
//   '& .MuiInputBase-root': {
//     backgroundColor: '#fff',
//   },
//   '& .MuiInputBase-root.Mui-focused': {
//     backgroundColor: '#fff',
//   },
//   '& .MuiInputBase-root:hover': {
//     backgroundColor: '#fff',
//   },
//   '& .MuiInputBase-root.Mui-disabled': {
//     backgroundColor: '#f5f5f5',
//   },
//   '& .MuiInputBase-input': {
//     backgroundColor: '#fff',
//   },
//   '& .MuiOutlinedInput-notchedOutline': {
//     borderColor: '#bdbdbd',
//   },
//   '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
//     borderColor: '#111',
//   },
// };

function Login() {
  const { register, handleSubmit, formState: { errors }, watch } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [apiError, setApiError] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(clearAuthError());
    setApiError('');
    if (localStorage.getItem('token')) {
      navigate('/dashboard');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, dispatch]);

  // useEffect(() => {
  //   setApiError(error || '');
  // }, [error]);

  const emailValue = watch('email');
  const passwordValue = watch('password');
  const [lastSubmitted, setLastSubmitted] = useState({ email: '', password: '' });

  useEffect(() => {
    if (!apiError) return;
    const emailChanged = emailValue !== lastSubmitted.email;
    const passwordChanged = passwordValue !== lastSubmitted.password;
    if (emailChanged || passwordChanged) setApiError('');
  }, [emailValue, passwordValue, apiError, lastSubmitted]);

  const onSubmit = async (data) => {
    try {
      setLastSubmitted({ email: data.email, password: data.password });
      await dispatch(login(data.email, data.password));
      navigate('/dashboard');
    } catch (e) {
      setApiError(e?.message || 'Invalid email or password');
    }
  };

  const handleNavigate = (path) => {
    dispatch(clearAuthError());
    setApiError('');
    navigate(path);
  };

  return (
    <AuthLayout>
      <h2 style={{ fontWeight: 800, marginBottom: 22, textAlign: 'left', fontFamily: 'Inter, sans-serif', color: '#e2e8f0' }}>Sign in</h2>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div style={{ marginBottom: 14 }}>
            <TextField
              label="Email"
              type="email"
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{ style: { background: 'transparent', color: '#e2e8f0' } }}
              sx={{
                '& .MuiOutlinedInput-root fieldset': { borderColor: '#334155' },
                '& .MuiOutlinedInput-root:hover fieldset': { borderColor: '#64748b' },
                '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#ffffff' },
                '& .MuiInputBase-input': { color: '#e2e8f0' },
                '& .MuiInputLabel-root': { color: '#e2e8f0' },
                '& .MuiInputLabel-root.Mui-focused': { color: '#ffffff' },
                '& .MuiInputLabel-root.MuiInputLabel-shrink': { color: '#e2e8f0' },
                '& input:-webkit-autofill': {
                  WebkitBoxShadow: '0 0 0 1000px #1d283a inset',
                  WebkitTextFillColor: '#e2e8f0',
                  caretColor: '#e2e8f0',
                },
              }}
              {...register('email', { required: 'Email is required' })}
              error={!!errors.email}
              helperText={errors.email ? errors.email.message : ''}
            />
          </div>
          <div style={{ marginBottom: 6 }}>
            <TextField
              label="Password"
              type={showPassword ? 'text' : 'password'}
              fullWidth
              variant="outlined"
              size="small"
               InputProps={{
                style: { background: 'transparent', color: '#e2e8f0' },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword((show) => !show)} edge="end" size="small" sx={{ color: '#ffffff' }}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root fieldset': { borderColor: '#334155' },
                '& .MuiOutlinedInput-root:hover fieldset': { borderColor: '#64748b' },
                '& .MuiOutlinedInput-root.Mui-focused fieldset': { borderColor: '#ffffff' },
                '& .MuiInputBase-input': { color: '#e2e8f0' },
                '& .MuiInputLabel-root': { color: '#e2e8f0' },
                '& .MuiInputLabel-root.Mui-focused': { color: '#ffffff' },
                '& .MuiInputLabel-root.MuiInputLabel-shrink': { color: '#e2e8f0' },
                '& input:-webkit-autofill': {
                  WebkitBoxShadow: '0 0 0 1000px #1d283a inset',
                  WebkitTextFillColor: '#e2e8f0',
                  caretColor: '#e2e8f0',
                },
              }}
              {...register('password', { required: 'Password is required' })}
              error={!!errors.password}
              helperText={errors.password ? errors.password.message : ''}
            />
          </div>
          <Button
            type="submit"
            fullWidth
            disabled={loading}
            variant="contained"
            sx={{ background: '#2563eb', color: '#fff', fontWeight: 700, fontSize: 16, mb: 1, borderRadius: 2, py: 1,
              '&:hover': { background: '#1e40af' } }}
          >
            {loading ? 'Signing in...' : 'Login'}
          </Button>
          {apiError && (
            <div style={{
              background: '#fdecea',
              color: '#b71c1c',
              border: '1px solid #f5c6cb',
              borderRadius: 8,
              padding: '10px 12px',
              textAlign: 'center',
              fontWeight: 600,
              marginTop: 10,
            }}>
              {apiError}
            </div>
          )}
      </form>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 12 }}>
        {/* <button type="button" onClick={()=>handleNavigate('/register')} style={{ background: 'none', border: 'none', padding: 0, color: '#94a3b8', fontWeight: 500, textDecoration: 'none', cursor: 'pointer' }}>Create account</button> */}
        <button type="button" style={{ background: 'none', border: 'none', padding: 0, color: '#94a3b8', fontWeight: 500, textDecoration: 'none', cursor: 'pointer' }}></button>
        <button type="button" onClick={()=>handleNavigate('/forgot-password')} style={{ background: 'none', border: 'none', padding: 0, color: '#94a3b8', fontWeight: 500, textDecoration: 'none', cursor: 'pointer' }}>Forgot password?</button>
      </div>
      
      {/* Terms and Conditions link positioned at bottom left */}
      {/* <div style={{ 
        position: 'absolute', 
        bottom: 20, 
        left: 20, 
        zIndex: 10 
      }}>
        <button 
          type="button" 
          onClick={()=>handleNavigate('/terms-and-conditions')} 
          style={{ 
            background: 'none', 
            border: 'none', 
            padding: 0, 
            color: '#94a3b8', 
            fontWeight: 500, 
            textDecoration: 'none', 
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Terms & Conditions
        </button>
      </div> */}

      {/* Privacy Policy link positioned at bottom right */}
      <div style={{ 
        position: 'absolute', 
        bottom: 20, 
        right: 20, 
        zIndex: 10 
      }}>
        <button 
          type="button" 
          onClick={()=>handleNavigate('/privacy-policy')} 
          style={{ 
            background: 'none', 
            border: 'none', 
            padding: 0, 
            color: '#94a3b8', 
            fontWeight: 500, 
            textDecoration: 'none', 
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Privacy Policy
        </button>
        {
          " | "
        }<button 
          type="button" 
          onClick={()=>handleNavigate('/terms-and-conditions')} 
          style={{ 
            background: 'none', 
            border: 'none', 
            padding: 0, 
            color: '#94a3b8', 
            fontWeight: 500, 
            textDecoration: 'none', 
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Terms & Conditions
        </button>
      </div>
    </AuthLayout>
  );
}

export default Login;
